module.exports = __webpack_public_path__ + "img/newBanner1EN.f6452986.jpg";